import { ExModule } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: State = {
  applicationPlan: undefined,
  applicationCompetitorEmbeddeds: [],
  applicationStudentEmbeddeds: [],
  selectedEvent: undefined,
  selectedCompany: undefined,
  selectedStudent: undefined,
  selectedUniversityId: undefined,
  selectedStudentTrendCategory: undefined,
  speechBubble: {
    position: {
      top: "auto",
      left: "auto",
      bottom: "auto",
      right: "bottom"
    },
    vertexDirection: "top"
  },
  competitorSearchParams: {
    company_name: undefined,
    limit: 20,
    offset: 0,
    sort: ""
  },
  companies: [],
  companiesTotal: 0,
  universities: undefined,
  editPlanView: {
    error: undefined
  },
  isLoading: false,
  isCreateEventViewVisible: false,
  isEditEventViewVisible: false,
  isDeleteEventViewVisible: false,
  isEditPlanViewVisible: false,
  isConfirmDestroyViewVisible: false,
  isCompetitorViewVisible: false,
  isUniversityViewVisible: false,
  planSettings: {
    timeLineMagnification: 1,
    isShowOwnEventTimeline: true,
    isShowCompetitorEventTimeline: true,
    isShowUniversityEventTimeline: true,
    isShowStudentTrendTimeline: true
  },
  selectedGraduateYears: []
};

const planModule: ExModule<State, Actions, Getters, Mutations> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default planModule;
